import {
  Component,
  ViewChild,
  ElementRef,
  Input,
  SimpleChanges,
  OnChanges,
  AfterViewInit,
} from "@angular/core";
import * as pbi from "powerbi-client";
import { environment } from "../../../../environments/environment";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "cdk-powerbi-report",
  templateUrl: "./powerbi.component.html",
  styleUrls: ["./powerbi.component.scss"],
})
export class PowerbiComponent implements OnChanges, AfterViewInit {
  private report: pbi.Embed;
  @ViewChild("reportContainer", { static: false })
  private reportContainer: ElementRef;

  @Input() token: string;
  @Input() report_id: string;

  private _pbi = new pbi.service.Service(
    pbi.factories.hpmFactory,
    pbi.factories.wpmpFactory,
    pbi.factories.routerFactory
  );

  constructor(public _route: ActivatedRoute) { }

  ngOnChanges(changes: SimpleChanges): void {
    const { token, report_id } = changes;
    this.token = token.currentValue;
    this.report_id = report_id.currentValue;
  }

  ngAfterViewInit(): void {
    if (this.token && this.report_id && this.reportContainer) {
      this.generateReport();
    }
  }

  async generateReport() {
    if (this.reportContainer) {
      this._pbi.reset(this.reportContainer.nativeElement);
      this.showReport(this.token, this.report_id);
    }

  }

  showReport(token: string, id: string) {
    const embedUrl = environment.powerBI.reportBaseURL;

    const settings: pbi.IEmbedSettings = {
      filterPaneEnabled: false,
      navContentPaneEnabled: false,
    };

    const config: pbi.IEmbedConfiguration = {
      accessToken: token,
      embedUrl,
      id,
      tokenType: pbi.models.TokenType.Embed,
      type: "report",
      pageView: "fitToWidth",
      filters: [],
      settings,
    };

    const reportContainer = this.reportContainer.nativeElement;
    this.report = this._pbi.embed(reportContainer, config);

    this.report.off("loaded");
    this.report.on("loaded", (value) => {
      // not todo
    });
    this.report.on("error", (error) => {
      // not todo
    });
  }
}
